import http from '@/v2/utils/http'
export default {
  getScanPaperSummary: (params) => http.post('/marking-exam-manager/exam-dashboard/student-paper/school/count', params),
  exportStudent: (params) => http.post('/marking-exam-manager/student-score/excel/student', params), // 导出未上传、已经上传、缺考、免考、学生的接口
  getExamNotUploadCount: (params) => http.get('/marking-exam-manager/exam-dashboard/unUpload/count', params),
}